import { RecipientCredentials } from './../../types/recipient-credentials.response.type';
import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { StatusDescriptionPipe } from '../../pipes/status-description.pipe';
import { TypeDescriptionPipe } from '../../pipes/type-description.pipe';
import { CredentialsService } from '../../services/credentials.service';
import { CredentialsStateService } from '../../services/credentials-state.service';
import { Subscription } from 'rxjs';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { YesornoDialogComponent } from '../yesorno-dialog/yesorno-dialog.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CredentialsViewComponent } from '../credentials/credentials-view/credentials-view.component';
@Component({
  selector: 'app-credentials-list',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    StatusDescriptionPipe,
    TypeDescriptionPipe,
    NgxMaskPipe,
    DatePipe,
    TableModule,
    ButtonModule,
    DynamicDialogModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [provideNgxMask(), DialogService, MessageService],
  template: `
    <p-toast></p-toast>
    <div class="container">
      <div class="item">
        @if(this.valor){
        <p-table
          [value]="dataSource"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 20, 50]"
          responsiveLayout="scroll"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="mobile-hidden column-type">Tipo</th>
              <th class="mobile-hidden column-tea"></th>
              <th class="mobile-hidden column-credential">Número da Credencial</th>
              <th class="mobile-hidden column-applicant">Solicitante</th>
              <th class="mobile-hidden column-process">Número do Processo</th>
              <th class="mobile-hidden column-date">Emissão</th>
              <th class="mobile-hidden column-date">Validade</th>
              <th class="mobile-hidden column-status">Status</th>
              <th class="mobile-hidden column-action">Ações</th>
              <th class="desktop-hidden">Detalhes</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-element>
            <tr>
              <td class="mobile-hidden column-type">
                <img
                  [src]="getButtonTypeImage(element.type)"
                  [title]="element.type | typeDescription"
                  width="35"
                  height="35"
                  style="margin-right: 5px; border-radius: 5px;"
                />
              </td>
              <td class="mobile-hidden column-tea">
                <img
                  [src]="getAutismImage(element.isTea)"
                  [title]="element.isTea | typeDescription"
                  width="35"
                  height="35"
                  style="margin-right: 5px; border-radius: 5px;"
                />
              </td>
              <td class="mobile-hidden column-credential">
                <strong>{{ element.credentialNumber | mask : '9999999/9999' }}</strong>
              </td>
              <td class="mobile-hidden column-applicant">
                {{ element.applicantSummary.name }}
              </td>
              <td class="mobile-hidden column-process">
                {{ element.processNumber | mask : 'A999999/9999' }}
              </td>
              <td class="mobile-hidden column-date">
                {{ element.createdAt | date : 'd/M/yyyy' }}
              </td>
              <td class="mobile-hidden column-date">
                {{
                  element.expiringDate > '2124-01-01'
                    ? 'Não Expira'
                    : (element.expiringDate | date : 'd/M/yyyy')
                }}
              </td>
              <td class="mobile-hidden column-status">
                <button
                  pButton
                  type="button"
                  [ngClass]="getButtonStatusClass(element.status)"
                  [label]="element.status | statusDescription"
                ></button>
              </td>
              <td class="mobile-hidden column-action">
                <div style="display: flex; gap: 0.25rem; align-items: center;">
                  <p-button
                    icon="pi pi-eye"
                    styleClass="view-button p-button-text p-button-rounded p-button-sm"
                    (onClick)="viewCredentialDetails(element.credentialNumber)"
                    pTooltip="Ver Detalhes">
                  </p-button>
                  <p-button
                    *ngIf="isSuperUser() && element.status === 'ATIVA'"
                    icon="pi pi-times-circle"
                    styleClass="cancel-button p-button-text p-button-rounded p-button-sm"
                    (onClick)="cancelCredential(element.id)"
                    pTooltip="Cancelar Credencial">
                  </p-button>
                  <p-button
                    *ngIf="element.status === 'ATIVA'"
                    icon="pi pi-file-pdf"
                    styleClass="pdf-button p-button-text p-button-rounded p-button-sm"
                    (onClick)="printCredential(
                      element.id,
                      element.credentialNumber + ' ' + element.recipientSummary.name
                    )"
                    pTooltip="Visualizar Credencial">
                  </p-button>
                </div>
              </td>
              <td class="desktop-hidden">
                <div class="mobile-row">
                  <div class="mobile-header">
                    <img
                      [src]="getButtonTypeImage(element.type)"
                      [title]="element.type | typeDescription"
                      width="35"
                      height="35"
                    />
                    <img
                      [src]="getAutismImage(element.isTea)"
                      [title]="element.isTea | typeDescription"
                      width="35"
                      height="35"
                    />
                    <strong>{{ element.credentialNumber | mask : '9999999/9999' }}</strong>
                  </div>
                  <div>{{ element.applicantSummary.name }}</div>
                  <div class="mobile-dates">
                    <span>Emissão: {{ element.createdAt | date : 'd/M/yy' }}</span>
                    <span>
                      Validade:
                      {{
                        element.expiringDate > '2124-01-01'
                          ? 'Não Expira'
                          : (element.expiringDate | date : 'd/M/yy')
                      }}
                    </span>
                  </div>
                  <div class="mobile-actions">
                    <p-button
                      label="Ver Detalhes"
                      icon="pi pi-eye"
                      styleClass="view-mobile-button p-button-sm"
                      (onClick)="viewCredentialDetails(element.credentialNumber)">
                    </p-button>
                    <button
                      pButton
                      type="button"
                      [ngClass]="getButtonStatusClass(element.status)"
                      [label]="element.status | statusDescription">
                    </button>
                    @if(element.status === 'ATIVA' && isSuperUser()){
                    <p-button
                      label="Cancelar"
                      icon="pi pi-times-circle"
                      styleClass="cancel-mobile-button p-button-sm"
                      (onClick)="cancelCredential(element.id)">
                    </p-button>
                    }
                    @if(element.status === 'ATIVA'){
                    <p-button
                      label="Visualizar PDF"
                      icon="pi pi-file-pdf"
                      styleClass="pdf-mobile-button p-button-sm"
                      (onClick)="printCredential(
                        element.id,
                        element.credentialNumber + ' ' + element.recipientSummary.name
                      )">
                    </p-button>
                    }
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        }
      </div>
    </div>

  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        margin: 0;
        padding: 0;
      }

      .container {
        display: block;
        width: 100%;
        padding: 0;
        margin: 0;
      }

      .item {
        width: 100%;
        overflow-x: auto;
        padding: 0 !important; /* Remove padding interno */
        margin: 0;
      }

      table {
        width: 100% !important;
        table-layout: fixed;
        margin: 0;
        border-collapse: collapse;
      }

      /* Remove qualquer margem/padding das células */
      th,
      td {
        padding: 8px 4px !important;
        margin: 0;
        border-bottom: 1px solid #e0e0e0; /* Linha divisória */
      }

      /* Remove a borda da última linha */
      tr:last-child td {
        border-bottom: none;
      }

      /* Opcional: adiciona borda no header se quiser */
      th {
        border-bottom: 2px solid #e0e0e0;
      }

      /* Larguras específicas para cada coluna */
      .column-type {
        width: 40px !important;
        min-width: 40px;
        max-width: 40px;
      }

      .column-tea {
        width: 40px !important;
        min-width: 40px;
        max-width: 40px;
      }

      .column-credential {
        width: 140px !important;
        min-width: 140px;
        max-width: 140px;
      }

      .column-applicant {
        width: 250px !important;
        min-width: 200px;
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .column-process {
        width: 120px !important;
        min-width: 120px;
        max-width: 120px;
      }

      .column-date {
        width: 100px !important;
        min-width: 90px;
        max-width: 110px;
      }

      .column-status {
        width: 180px !important;
        min-width: 150px;
        max-width: 180px;
      }

      .column-action {
        width: 180px !important;
        min-width: 150px;
        max-width: 180px;
      }

      .mobile-hidden {
        display: table-cell;
      }

      .desktop-hidden {
        display: none;
      }

      /* Estilos dos botões */
      .red-button {
        background-color: #dc3545 !important;
        color: white !important;
      }

      .green-button {
        background-color: #28a745 !important;
        color: white !important;
      }

      .grey-button {
        background-color: #bebebe !important;
        color: white !important;
      }

      .orange-button {
        background-color: orange !important;
        color: white !important;
      }

      .yellow-button {
        background-color: #ffc107 !important;
        color: white !important;
      }
      /* Botão Ver Detalhes */
      :host ::ng-deep .view-button {
        color: rgb(16, 148, 158) !important;
      }

      :host ::ng-deep .view-button:hover {
        background-color: rgba(16, 148, 158, 0.1) !important;
      }

      /* Botão Cancelar */
      :host ::ng-deep .cancel-button {
        color: #dc3545 !important;
      }

      :host ::ng-deep .cancel-button:hover {
        background-color: rgba(220, 53, 69, 0.1) !important;
      }

      /* Botão PDF */
      :host ::ng-deep .pdf-button {
        color: #e74c3c !important;
      }

      :host ::ng-deep .pdf-button:hover {
        background-color: rgba(231, 76, 60, 0.1) !important;
      }

      :host ::ng-deep .view-mobile-button {
        background-color: rgb(16, 148, 158) !important;
        border-color: rgb(16, 148, 158) !important;
        color: white !important;
        width: 100%;
      }

      :host ::ng-deep .view-mobile-button:hover {
        background-color: rgb(6, 182, 212) !important;
        border-color: rgb(6, 182, 212) !important;
      }

      :host ::ng-deep .cancel-mobile-button {
        background-color: #dc3545 !important;
        border-color: #dc3545 !important;
        color: white !important;
        width: 100%;
      }

      :host ::ng-deep .cancel-mobile-button:hover {
        background-color: #c82333 !important;
        border-color: #bd2130 !important;
      }

      :host ::ng-deep .pdf-mobile-button {
        background-color: #e74c3c !important;
        border-color: #e74c3c !important;
        color: white !important;
        width: 100%;
      }

      :host ::ng-deep .pdf-mobile-button:hover {
        background-color: #c0392b !important;
        border-color: #a93226 !important;
      }
      .red-button,
      .green-button,
      .grey-button,
      .orange-button,
      .yellow-button {
        width: 80px;
        height: 30px;
        font-size: 12px;
        min-width: unset;
        margin: 2px;
        padding: 4px 8px !important;
        border: none !important;
      }

      /* Estilo para hover */
      button.p-button:hover {
        opacity: 0.9;
        transform: translateY(-1px);
      }

      .custom-icon {
        width: 40px;
        height: 40px;
        cursor: pointer;
        margin: 0;
        padding: 0;
      }

      /* Estilos mobile */
      .mobile-row {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;
        background-color: #f5f5f5;
        border-radius: 8px;
        margin: 4px 0;
        width: 100%;
        box-sizing: border-box;
      }

      .mobile-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
      }

      .mobile-dates {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 0.9em;
        color: #666;
      }

      .mobile-actions {
        display: flex;
        gap: 8px;
        margin-top: 8px;
        flex-wrap: wrap;
      }

      /* Media Query para mobile */
      @media (max-width: 768px) {
        /* Remove larguras fixas em mobile */
        .column-type,
        .column-tea,
        .column-credential,
        .column-applicant,
        .column-process,
        .column-date,
        .column-status,
        .column-action {
          width: auto !important;
          min-width: auto;
          max-width: none;
        }

        .mobile-hidden {
          display: none !important;
        }

        .desktop-hidden {
          display: table-cell !important;
        }

        .mobile-dates {
          flex-direction: column;
          gap: 4px;
        }

        .mobile-actions {
          flex-direction: column;
          width: 100%;
        }

        .mobile-row {
          padding: 10px;
          margin: 2px 0;
        }

        .red-button,
        .green-button,
        .grey-button,
        .orange-button,
        .yellow-button {
          width: 100%;
          height: 40px;
          font-size: 12px;
          min-width: unset;
          margin: 2px 0;
        }

        .custom-icon {
          width: 30px;
          margin: 0 auto;
        }

        /* Ajusta padding das células em mobile */
        th,
        td {
          padding: 6px 2px !important;
        }
      }

      /* Media Query para telas muito pequenas */
      @media (max-width: 480px) {
        .item {
          padding: 0 !important;
        }

        .mobile-header {
          gap: 8px;
          flex-wrap: wrap;
        }

        .mobile-row {
          padding: 8px;
        }

        th,
        td {
          padding: 4px 1px !important;
        }
      }

      :host ::ng-deep .p-dialog {
        border-radius: 5px;
      }

      :host ::ng-deep .p-dialog .p-dialog-header {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }

      :host ::ng-deep .p-dialog .p-dialog-content {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      :host ::ng-deep .p-dialog .p-dialog-footer {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    `,
  ],
})
export class CredentialsListComponent
  implements OnChanges, OnInit, OnDestroy
{
  isLoadingPdf = false;

  @Output() reloadRequested = new EventEmitter<void>();

  @Input() valor: RecipientCredentials[] | undefined;
  dataSource: RecipientCredentials[] = [];

  private credentialCancelledSubscription!: Subscription;
  private credentialCreatedSubscription!: Subscription;

  constructor(
    private credentialsService: CredentialsService,
    private credentialsStateService: CredentialsStateService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit() {
    // Inscreva-se para escutar os eventos de cancelamento e criação
    this.setupStateSubscriptions();
  }

  private setupStateSubscriptions(): void {
    this.credentialCancelledSubscription =
      this.credentialsStateService.credentialCancelled$.subscribe(
        (cancelled) => {
          if (cancelled) {
            // console.log('Credencial cancelada detectada na lista');
            this.cdr.detectChanges(); // Força atualização da view
          }
        }
      );

    this.credentialCreatedSubscription =
      this.credentialsStateService.credentialCreated$.subscribe((created) => {
        if (created) {
          this.reloadRequested.emit(); // ← Notifica o componente pai para recarregar
        }
      });
  }

  ngOnDestroy(): void {
    // Limpe as inscrições para evitar memory leaks
    if (this.credentialCancelledSubscription) {
      this.credentialCancelledSubscription.unsubscribe();
    }

    if (this.credentialCreatedSubscription) {
      this.credentialCreatedSubscription.unsubscribe();
    }
  }
  /*
  ngOnChanges(changes: SimpleChanges) {
    if (this.valor) {
      this.dataSource.data = this.valor;
    }
    this.cdr.detectChanges();
  }*/
  private sortCredentials(
    credentials: RecipientCredentials[]
  ): RecipientCredentials[] {
    return [...credentials].sort((a, b) => {
      // 1. PRIORIDADE: Credenciais ATIVAS no topo
      if (a.status === 'ATIVA' && b.status !== 'ATIVA') return -1;
      if (a.status !== 'ATIVA' && b.status === 'ATIVA') return 1;

      // 2. SEGUNDA PRIORIDADE: Credenciais que "Não Expiram"
      const isNonExpiringA = a.expiringDate > '2124-01-01';
      const isNonExpiringB = b.expiringDate > '2124-01-01';

      if (isNonExpiringA && !isNonExpiringB) return -1;
      if (!isNonExpiringA && isNonExpiringB) return 1;

      // 3. TERCEIRA PRIORIDADE: Data de expiração (mais recente primeiro)
      const expirationA = new Date(a.expiringDate);
      const expirationB = new Date(b.expiringDate);

      if (expirationA.getTime() !== expirationB.getTime()) {
        return expirationB.getTime() - expirationA.getTime();
      }

      // 4. CRITÉRIO DE DESEMPATE: Data de criação (mais recente primeiro)
      const creationA = new Date(a.createdAt);
      const creationB = new Date(b.createdAt);

      return creationB.getTime() - creationA.getTime();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.valor) {
      const sortedData = this.sortCredentials(this.valor);
      this.dataSource = sortedData;

      // Debug: verifique a ordenação no console
      // console.log(
      //   'Credenciais ordenadas:',
      //   sortedData.map((c) => ({
      //     id: c.id,
      //     status: c.status,
      //     expiringDate: c.expiringDate,
      //     createdAt: c.createdAt,
      //   }))
      // );
    }
    this.cdr.detectChanges();
  }

  isSuperUser(): boolean {
    const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    return roles.includes('ROLE_SUPERUSER');
  }

  getButtonStatusClass(status: string): string {
    switch (status) {
      case 'CANCELADA':
      case 'CASSADA':
        return 'red-button';
      case 'ATIVA':
        return 'green-button';
      case 'VENCIDA':
        return 'grey-button';
      case 'AGUARDANDO_ASSINATURA':
        return 'yellow-button';
      default:
        return '';
    }
  }

  getButtonTypeImage(type: string): string {
    switch (type) {
      case 'PCDTEMPORARY':
        return '/assets/images/pcd-temp.png';
      case 'PCDPERMANENT':
        return '/assets/images/pcd.png';
      case 'IDOSO':
        return '/assets/images/idoso.png';
      default:
        return '/assets/images/default.png';
    }
  }

  getAutismImage(isTea: boolean): string {
    return isTea
      ? '/assets/images/tea.png'
      : '/assets/images/no-image.png';
  }

  getButtonToolClass(status: string): string {
    return status === 'ATIVA' ? 'orange-button' : '';
  }

  cancelCredential(credentialId: number): void {
    this.dialogService.open(YesornoDialogComponent, {
      header: 'Confirmação',
      width: '350px',
      data: {
        type: 'cancelCredential',
        credentialId,
        message: 'Deseja Cancelar esta Credencial?',
      },
      closable: false,
    });
  }

 printCredential(credentialId: number, credentialNumber: string): void {
  this.isLoadingPdf = true;
  
  // console.log('🖨️ Buscando credencial ID:', credentialId);
  
  this.credentialsService.getCredential(credentialId).subscribe({
    next: (blob: Blob) => {
      this.isLoadingPdf = false;
      // console.log('✅ Blob recebido:', blob.size, 'bytes');
      
      // TESTE: Abre em nova janela primeiro para verificar
      const testUrl = URL.createObjectURL(blob);
      // console.log('🔗 URL de teste:', testUrl);

      
      // Abre no viewer
     this.dialogService.open(CredentialsViewComponent, {
  data: {
    blob,
    fileName: `Credencial_${credentialNumber}.pdf`,
  },
  width: '90vw',
  height: '90vh',
  styleClass: 'pdf-dialog',
  modal: true,
  closable: true,
  closeOnEscape: true
});
      
    },
    error: (error: unknown) => {
      this.isLoadingPdf = false;
      this.handleCredentialError(error, 'Erro ao buscar credencial');
    }
  });
}

private handleCredentialError(error: unknown, context?: string): void {
  // console.error(`${context}:`, error);
  
  let errorMessage = 'Não foi possível carregar a credencial.';
  let errorDetail = '';
  
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else if (error && typeof error === 'object') {
    const errorObj = error as any;
    
    if (errorObj.status === 404) {
      errorMessage = 'Credencial não encontrada.';
      errorDetail = 'A credencial solicitada não existe no sistema.';
    } else if (errorObj.status === 500) {
      errorMessage = 'Erro interno do servidor.';
      errorDetail = 'Tente novamente mais tarde ou entre em contato com o suporte.';
    } else if (errorObj.message) {
      errorMessage = errorObj.message;
    }
  }
  
  this.messageService.add({
    severity: 'error',
    summary: errorMessage,
    detail: errorDetail,
    life: 6000,
  });
}

  viewCredentialDetails(credentialNumber: string): void {
    // Remove qualquer formatação (apenas números)
    const cleanCredentialNumber = credentialNumber.replace(/\D/g, '');
    
    // Define o número da credencial no serviço compartilhado
    this.credentialsStateService.setCredentialNumber(cleanCredentialNumber);
    
    // Navega para a página de consulta de credencial
    this.router.navigate(['/home/credential']);
  }
}
